/**
 * The product name, as a person reads it. Imported by the nav rail's brand block
 * and by the Inertia title callback in both entrypoints, so the sidebar and the
 * browser tab can never disagree.
 *
 * The Rails layout carries its own copy for the no-JS fallback `<title>` — see
 * `app/views/layouts/application.html.erb`. Change both together.
 */
export const BRAND = "IUPAT Portal"
